import 'typed';
import imagesLoaded from 'imagesloaded';
import { isInView } from 'isinview';
import Rellax from 'rellax';
import 'paroller.js';

let lastScrollTop = 0;

export function bodyUtils() {
  imagesLoaded.makeJQueryPlugin($);

  $('body').imagesLoaded(function() {
    $('body').addClass('loaded').trigger('loaded');
  });

  $('.wp-block-button.is-style-link .wp-block-button__link').each(function() {
    const svgElement = '<svg xmlns="http://www.w3.org/2000/svg" height="1em" fill="currentColor" viewBox="0 0 320 512"><path d="M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z"/></svg>';

    $(this).append(svgElement);
  });

  $('.wp-block-navigation__submenu-container').each(function() {
    $(this).prepend('<button aria-label="Close submenu" class="submenu-close-btn">Back</button>');
  });

  $('.submenu-close-btn').on('click', function() {
    $(this).parent().removeClass('active').siblings('.wp-block-navigation-item__content').attr('aria-expanded', false);
  });

  $('.open-on-click > button').on('click', function() {
    $('html').addClass('has-submenu-open');
    $('.wp-block-navigation-submenu').removeClass('active');
    $(this).parent().find('.wp-block-navigation-submenu').toggleClass('active');
  });

  if ($('.rellax').length) {
    new Rellax('.rellax:not(.wp-block-cover)', {
      speed: -10,
    });

    new Rellax('.rellax .wp-block-cover__image-background', {
      speed: -2,
    });
  }

  // Copy Me Button

  $('.is-style-copy-me .wp-element-button').click(function() {
    // Copy to clipboard
    navigator.clipboard.writeText($(this).attr('data-value'));

    // Save the original text
    var originalText = $(this).text();

    // Change text to 'Copied'
    $(this).text('Copied');

    // Set a timeout to revert back to the original text
    setTimeout(() => {
      $(this).text(originalText);
    }, 2000); // 2 seconds delay
  });
}

export function counterUtils() {

}

export function windowScrollUtils() {
  const $body = $('body');
  let st = $(window).scrollTop();
  const scrollThreshold = 20;

  if (st < ( lastScrollTop - scrollThreshold )) {
    $body.removeClass('header-hidden');
    $body.addClass('header-sticky');
  }

  if (st > lastScrollTop) {
    $body.addClass('header-hidden');
    $body.removeClass('header-sticky');
  }

  if (st < 50) {
    $body.addClass('top');
    $body.removeClass('header-sticky');
    $body.removeClass('header-hidden');
  }

  if (st > 50) {
    $body.removeClass('header-top');
  }

  lastScrollTop = st;
}

export function formUtils() {
// Function to check the value of the input or select
  function checkInput($input) {
    const $label = $input.closest('.gfield').find('.gform-field-label');

    if ($input.prop('readonly')) {
      $label.removeClass('active');
    } else if ($input.is('select') || $input.val() !== '' || $input.is(':focus')) {
      $label.addClass('active');
    } else {
      $label.removeClass('active');
    }
  }

// Apply the check on page load, focus, blur, and change events
  $('.gform_body').find('input[type="text"], input[type="email"], input[type="tel"], input[type="number"], select, textarea').each(function() {
    checkInput($(this));
  }).on('focus blur change', function() {
    checkInput($(this));
  });
}
